import { observable, makeObservable } from 'mobx';
import { ISpecificException } from './ISpecificExceptions';

export class SpecificReqExcData {
  public B1: ISpecificException[];
  public B2: ISpecificException[];

  constructor(
    { B1, B2 } = {
      B1: [],
      B2: [],
    }
  ) {
    makeObservable(this, {
      B1: observable,
      B2: observable
    });

    this.B1 = B1;
    this.B2 = B2;
  }
}
